/** True when running in development mode. */
export const IS_DEV: boolean =
	typeof process !== 'undefined' &&
	process.env.NODE_ENV !== 'production';

/** True when running in production mode. */
export const IS_PROD: boolean = !IS_DEV;

/** Application version sourced from package.json at build time. */
export const APP_VERSION: string =
	typeof process !== 'undefined' && process.env.npm_package_version
		? process.env.npm_package_version
		: '0.0.0';
